import { Http ,HttpFormType,HttpEmail,HttpCase} from "../Http";
export class AddLawFirmAPI {

     

public static addLawFirmDetails(input: any) {
  
  var obj=JSON.stringify(input);
  var url="formtypes/createLawFirm";

   var  lawFirmUserDetails={
  "employerName":input.lawfirmName,
	"employerCode":input.lawfirmCode,
	"zipCode":"0",
	"roleId":input.roleId,
	"daytimePhoneNumber":"",
	"faxNumber":"",
	"extention":"",
  "lawfirmId":null,
  "attorneyId":null,
	"emailId":input.emailAddress,
	"alternateEmailId":input.emailAddress,
    "userName":input.emailAddress,
    "subcriptionname":"SILVER",
    "password":input.password
  }

  var emailTemplate ={
    "toEmailIds":[input.emailAddress],   
    "ccEmailIds":["murugavelt.acumen@gmail.com"],   
    "customerEmail": input.emailAddress,
    "employerName": input.lawfirmName,
    "caseId":"116",
    "fillingUserName":input.emailAddress,
    "employerPhone":input.daytimePhoneNumber,
    "userId" : input.emailAddress,
    "password": input.password,
    "emailTemplate": "employer-setup"
  }
  
  const resultMethod = HttpFormType.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
 
      lawFirmUserDetails.lawfirmId = res.data.lawFirmAddressDetails.lawFirmId;
      Http.axios().post('api/addNewCreateLawFirmUserDetails',lawFirmUserDetails)
      .then((e) => {
      });

        HttpEmail.axios().post('email/employeeAccountCreationEmail',emailTemplate)
      .then((e) => {
 
     
      });
    
      
      return res;
    }).catch((e: any) => {
 
      return e.response;
    }); 
  return resultMethod; 
}

public static updateLawFirmDetails(input: any) {
 
  var obj=JSON.stringify(input);
  var url="formtypes/updateLawFirm";
 
 const resultMethod = HttpFormType.axios().put(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
 
      return res;
    }).catch((e: any) => {
 
      return e.response;
    });
  return resultMethod; 
}

public static  getAllLawFirmDetails(input: any){
  // getallCompanyAdditionalDetails
    var url = "formtypes/getLawFirmDetailsById/" + input.input;

//   alert(JSON.stringify(input)); 
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpFormType.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
    //    alert(JSON.stringify(res));
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    
    return resultMethod;  
}



public static addAttorneyDetails(input: any) {
 
  var obj=JSON.stringify(input);
  var url="formtypes/createAttorney/"+input.lawfirmId;
 
  var  attorneyUserDetails={
    "employeeId":input.employerId, 
    "emailId":input.emailAddress,   
    "roleId":input.roleId,
    "userName":input.emailAddress,
    "lawfirmId":input.lawfirmId,
    "attorneyId":null,
    "daytimePhoneNumber":input.attorneyAddressDetails.dayTimeTelNumber,
    "password":input.password,
    "attnLastName":input.attorneyAddressDetails.familyName,
    "attnFirstName":input.attorneyAddressDetails.firstName,    
    "attnMiddleName":input.attorneyAddressDetails.middleName
      
    }
    
  
      var emailTemplate ={
      "toEmailIds":[input.emailAddress],   
      "ccEmailIds":["murugavelt.acumen@gmail.com"],   
      "customerEmail": input.emailAddress,
      "employerName": input.attorneyAddressDetails.firstName,
      "caseId":"116",
      "fillingUserName":input.emailAddress,
      "employerPhone":input.attorneyAddressDetails.dayTimeTelNumber,
      "userId" : input.emailAddress,
      "password": input.password,
      "emailTemplate": "employer-setup"
    }
    
 

 const resultMethod = HttpFormType.axios().post(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
      attorneyUserDetails.attorneyId = res.data.attorneyAddressDetails.attorneyId
      Http.axios().post('api/addNewCreateAttorneyUserDetails',attorneyUserDetails)
      .then((e) => {
      });
      HttpEmail.axios().post('email/employeeAccountCreationEmail',emailTemplate)
      .then((e) => {
 
     
      });
      return res;
    }).catch((e: any) => {
 
      return e.response;
    }); 
  return resultMethod; 
}

public static updateAttorneyDetails(input: any) {
 
  var obj=JSON.stringify(input);
  var url="formtypes/updateAttorney";
 
 const resultMethod = HttpFormType.axios().put(url, obj,
    {
      headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
 
      return res;
    }).catch((e: any) => {
  
      return e.response;
    });
  return resultMethod; 
}

public static  getAllAttorneyDetails(input: any){
  // getallCompanyAdditionalDetails
    var url = "formtypes/getAttorneyDetailsById/" + input.input;

//   alert(JSON.stringify(input)); 
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpFormType.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
    //    alert(JSON.stringify(res));
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    
    return resultMethod;  
}




public static addCorporateDetails(input: any) {
 
  var obj=JSON.stringify(input);
  var url="formtypes/createVmCompanyProfile";
  if(input.attorneyId!=null){
    url=url+"?attorneyId="+input.attorneyId;
    if(input.lawFirmId!=null){
      url=url+"&lawFirmId="+input.lawFirmId;
    }
  }else{
    if(input.lawFirmId!=null){
      url=url+"?lawFirmId="+input.lawFirmId;
    }
  }

  var  corporateUserDetails={
    "employeeId":input.employerId, 
    "emailId":input.vmCompanyAddDetails.emailId,   
    "roleId":input.roleId,
    "userName":input.vmCompanyAddDetails.emailId,
    "lawfirmId":input.lawFirmId,
    "attorneyId":input.attorneyId,
    "daytimePhoneNumber":input.vmCompanyAddDetails.phoneNumber,
    "password":input.password,
    "attnLastName":input.vmCompanyAddDetails.attnLastName,
    "attnFirstName":input.vmCompanyAddDetails.attnFirstName,    
    "attnMiddleName":input.vmCompanyAddDetails.attnMiddleName
      
    }
    
  
     var emailTemplate ={
      "toEmailIds":[input.emailAddress],   
      "ccEmailIds":["murugavelt.acumen@gmail.com"],   
      "customerEmail": input.emailAddress,
      "employerName": input.vmCompanyAddDetails.firstName,
      "caseId":"116",
      "fillingUserName":input.vmCompanyAddDetails.emailId,
      "employerPhone":input.vmCompanyAddDetails.phoneNumber,
      "userId" : input.vmCompanyAddDetails.emailId,
      "password": input.password,
      "emailTemplate": "employer-setup"
    }
    
  /*
  var userInputInit={
    "companyCode":input.employerCode,
    "companyName":input.employerName,
   // description:input.,
   "address1":input.streetName,
   "address2":input.aptSteFlrNumber,
   "city":input.city,
   "state":input.state,
	 // country:input.,
   "zipCode":input.zipCode,
	  //status:input.,
	  "aptSteFlr":input.aptSteFlr,
    "vmCompanyAddDetails":{
      "phoneNumber":input.daytimePhoneNumber,
      "fein":input.fein,
    //  mobilenNmber:input.,
    "emailId":input.emailId,
    "attnFirstName":input.attnFirstName,
    "attnLastName":input.attnLastName,
    "attnMiddleName":input.attnMiddleName,
    "dateOfIncor":input.dateOfIncor,
    "businessType":input.typeOfBusiness,
    "naicsCode":input.naicsCode,
    "netIncome":input.netIncome,
    "noOfEmployees":input.noOfEmployees,
    "noOfH1bEmployees":input.noofH1bEmployees,
     // noOfL1aAndL1bEmployees:input.,
     "alternateEmailId":input.alternateEmailId,
     "signFirstName":input.signFirstName,
     "signLastName":input.signLastName,
     "signMiddlename":input.signMiddleName,
     "signTitleName":input.signTitle,
     "aboutCompany":input.aboutCompany,
     "h1bDependent":input.isEmprH1bDependent,
     "violator":input.isEmprViolator,
     "inHouseAttorney":input.isEmprAtorney,
     "grossIncome":input.grossIncome,
     "faxNumber":input.faxNumber,
     "extention":input.extention,
     "subcriptionName":input.subcriptionname
    
          },
          "vmCompanyH1bQuestions":{
            "h1bDependent":input.h1bdependent,
            "willfulViolator":input.willfulviolator,
            "moreThan50PerUS":input.morethan50perUS,
            "moreThan50PerH1bL1a":input.morethan50perh1bl1a,
            "higherEducationInstitution":input.highereducationinstitution,
            "nonProfitOrganization":input.nonprofitorganization,
            "nonProfitResearchOrganization":input.nonprofitresearchorganization,
            "subsequentRequestExtension":input.subsequentrequestextension,
            "amendedPetition":input.amendedpetition,
            "correctUscisError":input.correctusciserror,
            "secondaryEducationInstitution":input.secondaryeducationinstitution,
            "nonProfitEntity":input.nonprofitentity
        
          }

        }*/
    
       const resultMethod = HttpFormType.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
      
            corporateUserDetails.employeeId = res.data.autoId;
            Http.axios().post('api/addNewCreateCorporateUserDetails',corporateUserDetails)
            .then((e) => {
            });
            HttpEmail.axios().post('email/employeeAccountCreationEmail',emailTemplate)
            .then((e) => {
       
           
            });
            return res;
          }).catch((e: any) => {
       
            return e.response;
          });
        return resultMethod; 
      }

      public static updateCorporateDetails(input: any) {
 
        var obj=JSON.stringify(input);
        var url="formtypes/updateVmCompanyProfile";
      
      const resultMethod = HttpFormType.axios().put(url, obj,
          {
            headers: {
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*"
      }
    })
    .then(res => {
 
      return res;
    }).catch((e: any) => {
 
      return e.response;
    });
  return resultMethod; 
}

public static  getAllCorporateDetails(input: any){
  // getallCompanyAdditionalDetails
    var url = "formtypes/getVmCompanyProfileDetailsById/" + input.input;

//   alert(JSON.stringify(input)); 
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpFormType.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
    //    alert(JSON.stringify(res));
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    
    return resultMethod;  
}


public static  getAllCaseflowsByLawfirmId(input: any){
  // getallCompanyAdditionalDetails
    var url = "caseflow/getAllCaseflowsByLawFirmId/" + input.input;
    
//   alert(JSON.stringify(input)); 
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = HttpCase.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
    //    alert(JSON.stringify(res));
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    
    return resultMethod;  
}


public static  getAllLawFirmDetail(){
    var url = "formtypes/getAllLawFirmDetails/";
    const resultMethod = HttpFormType.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    
    return resultMethod;  
}

}


